module.exports = __webpack_public_path__ + "img/PT980388341.98a262af.png";